import React from 'react';

import { Box } from '@mui/material';

import LoginForm from '../../components/LoginForm';

const SsoScreen = () => {

  return (
    <Box maxWidth="md">
      <LoginForm />
    </Box>
  );
};

export default SsoScreen;
